

import _this from '../../lang/index.js'

const state = {
  linkQQ: '800185583',
  sidebarIsClose: sessionStorage.getItem('sidebarIsClose') || false,
  userInfo: {},
  dictionaries: {},
  weekList: [
    {
        name: _this.t('Monday'),
        id: 1
    },
    {
        name: _this.t('Tuesday'),
        id: 2
    },
    {
        name: _this.t('Wednesday'),
        id: 3
    },
    {
        name: _this.t('Thursday'),
        id: 4
    },
    {
        name: _this.t('Friday'),
        id: 5
    },
    {
        name: _this.t('Saturday'),
        id: 6
    },
    {
        name: _this.t('Sunday'),
        id: 7
    }
  ],
  lineTypeList: [
    {
        id: 1,
        name: _this.t('Direct')
    },
    {
        id: 2,
        name: _this.t('Transshipment')
    }
  ], // 转运方式list
  spaceStatusList: [
    {
        id: 1,
        name: _this.t('Normal')
    },
    {
        id: 2,
        name: _this.t('Nervous')
    },
    {
        id: 3,
        name: _this.t('PositionExplosion')
    }
  ],
  expressArr: [],
  landExportsFullArr: [],
  seaExportsFullArr: [],
  seaExportsPieceArr: []
}

const mutations = {
  SET_USER_INSTRUCTIONS: (state, data) => {
    state[data.type] = data.data;
  },
  TOGGLE_SIDEBAR: state => {
    state.sidebarIsClose = !state.sidebarIsClose;
  },
  SET_DICTIONARIES: (state, dictionaries) => {
    state.dictionaries = dictionaries;
  },
  // 联系我们
  LINK_US (state) {
    window.open('http://wpa.qq.com/msgrd?v=3&uin=' + state.linkQQ + '&site=qq&menu=yes')
  },
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  setDictionaries({ commit }, dictionaries) {
    commit('SET_DICTIONARIES', dictionaries)
  },
  // 登出
  logout () {
    sessionStorage.clear();
  },
  // 需要登录
  needLogin () {
    this.$confirm(_this.t('NotLogged'), _this.t('Prompt'), {
      confirmButtonText: _this.t('OK'),
      cancelButtonText: _this.t('Cancel'),
      type: 'warning'
    }).then(() => {
        this.$router.push({name: 'Login', query: {
            backName: this.$route.name
        }})
    }).catch(() => {});
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js